<template>
  <v-container>
    <v-row no-gutters color="transparent" elevation="0">
      <v-col class="left-column">
        <v-alert
          class="deprecation-alert"
          type="warning"
          prominent
          border="left"
          icon="mdi-alert-outline"
          colored-border
          elevation="2"
        >
          <div class="deprecation-alert-title">
            {{ $t("introduction.deprecationAlert.title") }}
          </div>
          <div class="deprecation-alert-body">
            {{ $t("introduction.deprecationAlert.body") }}
          </div>
          <v-btn
            small
            color="warning"
            class="mt-3"
            :href="newDocsUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t("introduction.deprecationAlert.cta") }}
            <v-icon right small>mdi-open-in-new</v-icon>
          </v-btn>
        </v-alert>

        <TextArea :textTitle="getTitle" :textLinesArray="getText"></TextArea>
      </v-col>
      <v-col class="right-column">
        <div>
          <CodeCard
            cardTitle="BASE URL"
            cardCode="https://externalaccessapi.e-komplet.dk/"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import CodeCard from "../components/content/CodeCard.vue";
import TextArea from "../components/content/TextArea.vue";

export default {
  components: {
    CodeCard,
    TextArea,
  },
  computed: {
    getTitle() {
      return this.$t("introduction.title");
    },
    getText() {
      return this.$t("introduction.text");
    },
    newDocsUrl() {
      const lang = this.$i18n.locale === "en" ? "en" : "da";
      return `https://externalaccessapi.e-komplet.dk/scalar/v4-${lang}`;
    },
  },
};
</script>
<style scoped>
.deprecation-alert {
  margin-top: 16px;
  margin-right: 10%;
  margin-bottom: 24px;
}

.deprecation-alert-title {
  font-size: 1.05rem;
  font-weight: 700;
  margin-bottom: 4px;
}

.deprecation-alert-body {
  font-size: 0.95rem;
  line-height: 1.4;
}
</style>